import * as React from 'react';

import { Flex } from '@lightspeed/flame/Core';

import Localize from 'app/src/localize/Localize';

import { PaymentInputField } from '../components/PaymentInputField';

export const CardAmount = ({ cardTotal, setCardTotal }: TSFixMe) => {
  return (
    <>
      <Flex flexWrap="wrap" py={1}>
        <span>{Localize.translate('1. Enter Charge Amount')}</span>
      </Flex>
      <Flex flexWrap="wrap" py={1} className="money-field-container payment-block-money">
        <PaymentInputField
          id="credit_card_amount"
          aria-label="Card amount"
          prefix={Localize.getCurrencySymbol()}
          autoComplete="off"
          value={cardTotal}
          onBlur={(value: TSFixMe) => setCardTotal(value)}
        />
      </Flex>
    </>
  );
};
